import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector, NgZone, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';


export interface SanitizedError {
  message: string;
  details: string[];
}

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly injector = inject(Injector);


  handleError(error: any): void {
    console.log('Error caught:', error);
    try {
      error.error = JSON.parse(error.error);
    } catch {
      // Don't convert to json. Keep as string.
    }
    const sanitised = this.sanitiseError(error);
    const ngZone = this.injector.get(NgZone);
    const snackBar = this.injector.get(MatSnackBar);

    ngZone.run(() => {
      snackBar.open(`Error Occured: '${sanitised.message}`, 'Close', {
        duration: 10000,
      });

    });
  }

  private sanitiseError(error: Error | HttpErrorResponse): SanitizedError {
    const sanitisedError: SanitizedError = {
      message: error?.message || '(null)',
      details: []
    };
    if (error instanceof Error && error.stack) {
      sanitisedError.details.push(error.stack);
    } else if (error instanceof HttpErrorResponse) {
      if (error.error) {
        const message = error.error?.message !== undefined ? error.error.message : error.error;
        sanitisedError.message = `${error.status}: ${message}`;
      }
      sanitisedError.details = Object.entries(error)
        .map(([key, value]) => `${key}: ${value}`);
    } else {
      sanitisedError.details.push(JSON.stringify(error));
    }
    return sanitisedError;
  }
}
